module.exports = __webpack_public_path__ + "static/media/background_1.79cd3039.jpg";